import React, { Component } from 'react';
import AuthService from '../../utils/AuthService';
import Page from '../Page';
import PageSection from '../PageSection';
import Table from '../Table';
import BMYForm from '../BMYForm';
import VesselForm from '../VesselForm';
import Popup from '../Popup';
import ButtonGroup from '../ButtonGroup';

var initialBuilderInfo = {
	selectedId: null,
	selectedText: ""
};

var initialModelInfo = {
	selectedId: null,
	selectedText: ""
};

var initialVesselInfo = {
	hullName: "",
	application: "",
	vesselUse: "",
	hullType: "",
	vesselInstallation: "",
	appendages: "",
	waterlineTransom: "",
	deadriseBwl: "",
	deadriseTransom: "",
	naturalRollPeriod: "",
	operationHours: "",
	notes: ""
};

const validationObject = [
	{
		"parent": "bmyInfo",
		"fieldName": "bmy_id",
		"required": true,
		"errorMessage": "Builder, Model, and Year are required"
	},
	{
		"parent": "vesselInfo",
		"fieldName": "fullLoad",
		"required": true,
		"errorMessage": "Full Load Displacement is required"
	},
	{
		"parent": "vesselInfo",
		"fieldName": "LOA",
		"required": true,
		"errorMessage": "Length Overall is required"
	},
	{
		"parent": "vesselInfo",
		"fieldName": "LWL",
		"required": true,
		"errorMessage": "Waterline Length is required"
	},
	{
		"parent": "vesselInfo",
		"fieldName": "BOA",
		"required": true,
		"errorMessage": "Beam Overall is required"
	},
	{
		"parent": "vesselInfo",
		"fieldName": "BWL",
		"required": true,
		"errorMessage": "Max Waterline Beam is required"
	}
];

class CreateBoat extends Component {
	constructor(props) {
		super(props);

		this.bmy_id = this.props.match.params.bmy_id;

		let loading = this.bmy_id === undefined ? false : true;
		this.path = props.path;

		this.Auth = new AuthService();
		this.validationObject = validationObject;

		this.state = {
			bmyInfo: {},
			builderInfo: initialBuilderInfo,
			modelInfo: initialModelInfo,
			year: "",
			vesselInfo: initialVesselInfo,
			createdInfo: false,
			unit: 'Metric',
			disableBMY: false,
			disableVessel: false,
			isNew: true,
			isEditingBMY: false,
			canEditBMY: false,
			canDeactivate: false,
			message: false,
			popupCallback: '',
			loading: loading,
			displaySaveButton: true,
			displayReports: false,
			tablePublished: {
				tableHeading: [],
				tableBody: []
			},
			errors: []
		};

		this.setBMY = this.setBMY.bind(this);
		this.changeBuilder = this.changeBuilder.bind(this);
		this.changeModel = this.changeModel.bind(this);
		this.changeYear = this.changeYear.bind(this);
		this.vesselInfoChange = this.vesselInfoChange.bind(this);
		this.createBoat = this.createBoat.bind(this);
		this.convertFeetToMeters = this.convertFeetToMeters.bind(this);
		this.convertLbsToKilo = this.convertLbsToKilo.bind(this);
		this.loadingButton = this.loadingButton.bind(this);
		this.removeLoadingButton = this.removeLoadingButton.bind(this);
		this.createBMY = this.createBMY.bind(this);
		this.showMessage = this.showMessage.bind(this);
		this.hideMessage = this.hideMessage.bind(this);
		this.unitChange = this.unitChange.bind(this);
		this.editBMYClick = this.editBMYClick.bind(this);
		this.cancelEdit = this.cancelEdit.bind(this);
		this.updateBMY = this.updateBMY.bind(this);

		this.confirmDeactivateBuilder = this.confirmDeactivateBuilder.bind(this);
		this.deactivateBuilder = this.deactivateBuilder.bind(this);
		this.confirmDeactivateModel = this.confirmDeactivateModel.bind(this);
		this.deactivateModel = this.deactivateModel.bind(this);
		this.confirmDeactivateSingleBoat = this.confirmDeactivateSingleBoat.bind(this);
		this.deactivateSingleBoat = this.deactivateSingleBoat.bind(this);

		this.reloadPage = this.reloadPage.bind(this);
	}

	componentDidMount() {
		if (this.path == '/view-boats/:bmy_id') {
			this.setState({
				disableBMY: true,
				disableVessel: true,
				displaySaveButton: false
			});
		}

		if (this.bmy_id) {
			this.Auth.fetch('/bmy/' + this.bmy_id)
			.then(
				(result) => {
					console.log(result);
					if (result.success === true) {
						let data = result.bmy;

						let createdName = "Admin";
						if(data.first_name !== null) {
							createdName = data.first_name;
						}
						if(data.last_name !== null) {
							createdName += " " + data.last_name;
						}
						this.setState({
							bmyInfo: {
								bmy_id: this.bmy_id
							},
							builderInfo: {
								selectedId: data.builder_id,
								selectedText: data.builder_name
							},
							modelInfo: {
								selectedId: data.model_id,
								selectedText: data.model_name
							},
							year: data.boat_year,
							isNew: false,
							vesselInfo: {
								fullLoad: data.displacement,
								GMT: data.gmt,
								GMT_est: data.gmt_est,
								LOA: data.loa,
								LWL: data.lwl,
								BOA: data.boa,
								BWL: data.bwl,
								appendages: data.draft_wo_appendages,
								waterlineTransom: data.waterline_beam_transom,
								deadriseBwl: data.deadrise_angle_bwl_max,
								deadriseTransom: data.deadrise_angle_hull_transom,
								naturalRollPeriod: data.troll,
								naturalRollPeriod_est: data.troll_est,
								operationHours: data.hours_of_operation,
								application: data.boat_application,
								subApplication: data.boat_sub_application,
								vesselUse: data.vessel_use,
								hullType: data.hull_type,
								vesselInstallation: data.vessel_installation,
								modelLength: data.model_length
							},
							createdInfo: {
								name: createdName,
								date: this.formatDate(data.date_created)
							},
							disableBMY: true,
							loading: false
						});

						let userProfile = this.Auth.getProfile();
						// admin role can edit and deactivate bmy data
						if(userProfile.pp_role_id === "1" || userProfile.pp_role_id === 1) {
							this.setState({
								canEditBMY: true,
								canDeactivate: true
							});
						}
					}
				},
				(error) => {
					this.setState({
						error
					});
				}
			);

			this.Auth.fetch('/prediction/sizing-form?bmy=' + this.bmy_id)
				.then((result) => {
					let header = ['Date Published', 'Published By', ''],
						rows = [];
					if (result.success === true) {

						for (let a = 0; a < result.data.length; a += 1) {
							let data = result.data[a],
								row = [];
							row.push(data.published_date);
							row.push(data.published_first_name + ' ' + data.published_last_name);
							row.push(<a href={"/report/" + data.report_id}>View Report</a>);
							rows.push(row);
						}

						this.setState({
							tablePublished: {
								tableHeading: header,
								tableBody: rows
							},
							displayReports: true
						});
					}
				});
		}
	}

	reloadPage() {
		window.location.reload();
	}

	formatDate(dateIn) {
		// convert published date
		const monthNames = ["January", "February", "March", "April", "May", "June",
			"July", "August", "September", "October", "November", "December"
		];

		// parse date for Safari
		let date = dateIn.split(" ")[0];
		let dateParts = date.split("-");
		let year = dateParts[0];
		let month = dateParts[1];
		let day = dateParts[2];

		const d = new Date(year, month - 1, day);
		let publishedMonth = monthNames[d.getMonth()];
		let publishedDay = d.getDate();
		let publishedYear = d.getFullYear();

		return publishedMonth + " " + publishedDay + ", " + publishedYear;
	}

	changeBuilder(builderInfo) {
		this.setState({
			builderInfo
		});
	}

	changeModel(modelInfo) {
		this.setState({
			modelInfo
		});
	}

	changeYear(year) {
		var digit = /^[0-9]+$/;
		if(year.length === 4 && digit.test(year) && this.state.isNew) {
			// we have a valid year, lets try to create bmy
			let formData = new FormData();
			let { modelInfo } = this.state;

			if(modelInfo.selectedId !== null) {
					formData.append("model_id", modelInfo.selectedId);
					formData.append("year", year);

				this.Auth.post('/check-bmy', formData)
				.then(
					(result) => {
						console.log(result);
						if(result.success === true) {
							this.setBMY(result.bmy);
							console.log(result.bmy.displacement);
							if (result.bmy.displacement != null || result.bmy.gmt != null || result.bmy.loa != null || result.bmy.lwl != null || result.bmy.boa != null || result.bmy.bwl != null) {
								this.showMessage('You can edit its data below', 'This boat already exists', <button className="pp-button" onClick={this.hideMessage}>OK</button>);
								this.bmy_id = result.bmy.bmy_id;
							}
						} else {
							if(result.messages) {
								this.showMessage(result.messages.join("\n"));
							}
						}
					},
					(error) => {
						this.setState({
							error
						});
					}
				);
			}
		}

		this.setState({
			year
		});
	}

	setBMY(bmy) {
		if(Object.getOwnPropertyNames(bmy).length == 0) {
			// empty bmy object
			this.setState({
				bmyInfo: bmy,
				vesselInfo: {
					...this.state.vesselInfo,
					fullLoad: bmy.displacement,
					GMT: bmy.gmt,
					GMT_est: bmy.gmt_est,
					LOA: bmy.loa,
					LWL: bmy.lwl,
					BOA: bmy.boa,
					BWL: bmy.bwl,
					appendages: bmy.draft_wo_appendages,
					waterlineTransom: bmy.waterline_beam_transom,
					deadriseBwl: bmy.deadrise_angle_bwl_max,
					deadriseTransom: bmy.deadrise_angle_hull_transom,
					naturalRollPeriod: bmy.troll,
					naturalRollPeriod_est: bmy.troll_est,
					operationHours: bmy.hours_of_operation,
					application: bmy.boat_application,
					subApplication: bmy.boat_sub_application,
					vesselUse: bmy.vessel_use,
					hullType: bmy.hull_type,
					vesselInstallation: bmy.vessel_installation
				},
				createdInfo: false
			});
			return false;
		}

		let createdName = "Admin";
		if(bmy.first_name !== null) {
			createdName = bmy.first_name;
		}
		if(bmy.last_name !== null) {
			createdName += " " + bmy.last_name;
		}
		this.setState({
			bmyInfo: bmy,
			vesselInfo: {
				...this.state.vesselInfo,
				fullLoad: bmy.displacement,
				GMT: bmy.gmt,
				GMT_est: bmy.gmt_est,
				LOA: bmy.loa,
				LWL: bmy.lwl,
				BOA: bmy.boa,
				BWL: bmy.bwl,
				appendages: bmy.draft_wo_appendages,
				waterlineTransom: bmy.waterline_beam_transom,
				deadriseBwl: bmy.deadrise_angle_bwl_max,
				deadriseTransom: bmy.deadrise_angle_hull_transom,
				naturalRollPeriod: bmy.troll,
				naturalRollPeriod_est: bmy.troll_est,
				operationHours: bmy.hours_of_operation,
				application: bmy.boat_application,
				subApplication: bmy.boat_sub_application,
				vesselUse: bmy.vessel_use,
				hullType: bmy.hull_type,
				vesselInstallation: bmy.vessel_installation
			},
			createdInfo: {
				name: createdName,
				date: this.formatDate(bmy.date_created)
			}
		});
	}

	vesselInfoChange(propName, propValue) {
		this.setState({
			vesselInfo: {
				...this.state.vesselInfo,
				[propName]: propValue
			}
		});
		// update any necessary BMY fields
		if(this.state.bmyInfo.hasOwnProperty(propName.toLowerCase())) {
			this.setState({
				bmyInfo: {
					...this.state.bmyInfo,
					[propName.toLowerCase()]: propValue
				}
			})
		}
	}

	unitChange(unit) {

		if(this.state.unit === unit) {
			return;
		}
		let { vesselInfo } = this.state;
		let tempVesselInfo = {};
		if(unit == "Metric") {
			// convert all numbers from English to Metric
			tempVesselInfo = {
				...vesselInfo,
				fullLoad: this.convertLbsToKilo(vesselInfo.fullLoad),
				BOA: this.convertFeetToMeters(vesselInfo.BOA),
				BWL: this.convertFeetToMeters(vesselInfo.BWL),
				LOA: this.convertFeetToMeters(vesselInfo.LOA),
				LWL: this.convertFeetToMeters(vesselInfo.LWL),
				appendages: this.convertFeetToMeters(vesselInfo.appendages),
				waterlineTransom: this.convertFeetToMeters(vesselInfo.waterlineTransom),
				GMT: this.convertFeetToMeters(vesselInfo.GMT),
				GMT_est: this.convertFeetToMeters(vesselInfo.GMT_est),
			}
		} else {
			// convert all numbers from Metric to English
			tempVesselInfo = {
				...vesselInfo,
				fullLoad: this.convertKiloToLbs(vesselInfo.fullLoad),
				BOA: this.convertMetersToFeet(vesselInfo.BOA),
				BWL: this.convertMetersToFeet(vesselInfo.BWL),
				LOA: this.convertMetersToFeet(vesselInfo.LOA),
				LWL: this.convertMetersToFeet(vesselInfo.LWL),
				appendages: this.convertMetersToFeet(vesselInfo.appendages),
				waterlineTransom: this.convertMetersToFeet(vesselInfo.waterlineTransom),
				GMT: this.convertMetersToFeet(vesselInfo.GMT),
				GMT_est: this.convertMetersToFeet(vesselInfo.GMT_est),
			}
		}

		this.setState({
			unit: unit,
			vesselInfo: tempVesselInfo
		});
	}

	editBMYClick() {
		this.setState({
			isEditingBMY: true,
			disableBMY: false
		});
	}

	cancelEdit() {
		this.setState({
			isEditingBMY: false,
			disableBMY: true
		});
	}

	updateBMY() {
		if (this.bmy_id) {
			let builderText = this.state.builderInfo.selectedText;
			let modelText = this.state.modelInfo.selectedText;
			let yearText = this.state.year;

			if(builderText !== "" && modelText !== "" && yearText !== "") {
				let formData = new FormData();

				formData.append("builder_name", builderText);
				formData.append("model_name", modelText);
				formData.append("year", yearText);

				this.Auth.post('/bmy-update/'+this.bmy_id, formData)
				.then(
					(result) => {
						if(result.success) {
							this.showMessage("BMY has been updated.", "", <button className="pp-button" onClick={this.hideMessage}>OK</button>);
							this.setState({
								isEditingBMY: false,
								disableBMY: true
							});
						} else {
							if(result.messages) {
								this.showMessage(result.messages.join("\n"));
							}
						}
					},
					(error) => {
						this.setState({
							error
						});
						this.showMessage('Something went wrong. Please try again later.');
					}
				);
			} else {
				alert("Builder, model, and year can not be empty.");
			}
		} else {
			alert("No BMY ID is set.");
		}
	}

	convertFeetToMeters(feet) {
		let meters = (feet / 3.2808);
		//meters = Math.floor(meters * 100000) / 100000;
		return meters;
	}

	convertMetersToFeet(meters) {
		let feet = (meters * 3.2808);
		//feet = Math.round(feet * 1000) / 1000;
		return feet;
	}

	convertKiloToLbs(kilo) {
		let lbs = (kilo * 2.2046);
		//lbs = Math.round(lbs * 1000) / 1000;
		return lbs;
	}

	convertLbsToKilo(lbs) {
		let kilo = (lbs / 2.2046);
		//kilo = Math.round(kilo * 1000) / 1000;
		return kilo;
	}

	loadingButton(target) {
		if(target) {
			target.disabled = true;
			target.classList.add('pp-loading');
		}
	}

	removeLoadingButton(target) {
		if(target) {
			target.disabled = false;
			target.classList.remove('pp-loading');
		}
	}

	showMessage(body, title, actionButtons) {
		var messageTitle = title || ' ',
			messageActionButtons = actionButtons || <button className="pp-button" onClick={this.hideMessage}>Close</button>;

		this.setState({
			message: {
				body: body,
				title: messageTitle,
				actionButtons: messageActionButtons
			}
		});
	}

	hideMessage() {
		this.setState({
			message: false
		});
	}

	validateSizingForm() {
		let validCount = this.validationObject.length;
		let errors = [];
		let stateErrors = {};
		let hasErrors = false;

		for(let i=0; i<validCount; i++) {
			if(this.validationObject[i].required) {
				if(this.validationObject[i].parent) {
					if( !this.state[this.validationObject[i].parent][this.validationObject[i].fieldName]) {
						let message = this.validationObject[i].errorMessage;
						errors.push(<p>{message}</p>);
						stateErrors[this.validationObject[i].fieldName] = true;
						hasErrors = true;
					}
				} else {
					if( !this.state[this.validationObject[i].fieldName]) {
						let message = this.validationObject[i].errorMessage;
						errors.push(<p>{message}</p>);
						stateErrors[this.validationObject[i].fieldName] = true;
						hasErrors = true;
					}
				}
			}
		}

		if(hasErrors) {
			this.showMessage(errors, "Required Fields");
			this.setState({
				errors: stateErrors
			});
		}

		return !hasErrors;
	}

	createBMY(callback) {
		var digit = /^[0-9]+$/;
		if(this.state.year.length === 4 && digit.test(this.state.year) && this.state.isNew) {
			// we have a valid year, lets try to create bmy
			let formData = new FormData();
			let { builderInfo, modelInfo } = this.state;
			if(builderInfo.selectedId !== null) {
				formData.append("builder_id", builderInfo.selectedId);
			}
			formData.append("builder_name", builderInfo.selectedText);

			if(modelInfo.selectedId !== null) {
					formData.append("model_id", modelInfo.selectedId);
			}
			formData.append("model_name", modelInfo.selectedText);
			formData.append("year", this.state.year);

			this.Auth.post('/create-bmy', formData)
			.then(
				(result) => {
					console.log(result);
					if(result.success === true) {
						this.setState({
							bmyInfo: result.bmy
						}, callback);
					} else {
						if(result.messages) {
							this.showMessage(result.messages.join("\n"));
						}
					}
				},
				(error) => {
					this.setState({
						error
					});
				}
			);
		}
	}

	createBoat(e) {
		let formData = new FormData();
		var target = e.target;
		const { vesselInfo, bmyInfo, modelInfo } = this.state;

		// check if we need to create new BMY
		if( !this.state.bmyInfo.bmy_id) {
			let self = this;
			let event = e;
			this.createBMY(function() {
				self.createBoat(event);
			});
			return;
		}

		if( !this.validateSizingForm()) {
			return;
		}

		this.loadingButton(target);

		let tempVesselInfo = vesselInfo;
		// check units, convert to metric for submission
		if(this.state.unit == "English") {
			// convert all numbers from English to Metric
			tempVesselInfo = {
				...vesselInfo,
				fullLoad: this.convertLbsToKilo(vesselInfo.fullLoad),
				BOA: this.convertFeetToMeters(vesselInfo.BOA),
				BWL: this.convertFeetToMeters(vesselInfo.BWL),
				LOA: this.convertFeetToMeters(vesselInfo.LOA),
				LWL: this.convertFeetToMeters(vesselInfo.LWL),
				appendages: this.convertFeetToMeters(vesselInfo.appendages),
				waterlineTransom: this.convertFeetToMeters(vesselInfo.waterlineTransom),
				GMT: this.convertFeetToMeters(vesselInfo.GMT),
			}
		}
		tempVesselInfo.units = this.state.unit;

		formData.append("vessel_info", JSON.stringify(tempVesselInfo));
		formData.append("bmy_id", bmyInfo.bmy_id);

		if (bmyInfo.bmy_id) {
			// we are updating an existing sizing form
			this.Auth.post('/bmy/' + bmyInfo.bmy_id, formData)
				.then(
					(result) => {
						console.log(result);
						if(result.success === true) {
							if (this.bmy_id !== undefined) {
								var buttons = <div className="pp-button-wrapper">
												<a href="/manage-boats" className="pp-button">Done</a>
												<p className="pp-instruction">or</p>
												<button className="pp-secondary-button" onClick={this.hideMessage}>Continue Editing</button>
											   </div>;
								this.showMessage('', 'This boat has been updated', buttons);
							} else {
								var buttons = <div className="pp-button-wrapper">
												<a href="/manage-boats" className="pp-button">Done</a>
												<p className="pp-instruction">or</p>
												<button className="pp-secondary-button" onClick={this.reloadPage}>Create Another Boat</button>
											   </div>;
								this.showMessage('', 'This boat has been saved', buttons);
							}
						} else {
							if(result.messages) {
								this.showMessage(result.messages.join("\n"));
							}
						}
						this.removeLoadingButton(target);
					},
					(error) => {
						this.setState({
							error
						});
						this.removeLoadingButton(target);
					}
				);
		} else {
			this.removeLoadingButton(target);
			this.showMessage("Please select a builder, model, and year.");
		}

		// update model length
		if (vesselInfo.modelLength !== '' && modelInfo.selectedId !== null) {
			formData.append("model_length", vesselInfo.modelLength);
			this.Auth.post('/model/' + modelInfo.selectedId, formData)
				.then(
					(result) => {
						console.log(result);
					}
				);
		}
	}

	confirmDeactivateBuilder() {
		var messageButtons = <span class="pp-button-wrapper">
			<button type="button" className="pp-button" onClick={this.deactivateBuilder}>Deactivate Builder</button>
			<p className="pp-instruction">or</p>
			<button type="button" className="pp-secondary-button" onClick={this.hideMessage}>Cancel</button>
		</span>;

		this.showMessage('Deactivating this builder will deactivate all models and boats under this builder as well as move all sizing forms/reports with this builder to the rejected state. Are you sure you want to deactivate the builder?', 'Deactivate this builder?', messageButtons);
	}

	deactivateBuilder() {
		if (this.state.bmyInfo.bmy_id) {
			let builderId = this.state.builderInfo.selectedId;

			if(builderId !== "") {
				let formData = new FormData();

				formData.append("builder_id", builderId);

				this.Auth.post('/deactivate/builder', formData)
				.then(
					(result) => {
						if(result.success) {
							this.showMessage("All models and single boats with this builder have been deactivated. All related sizing forms/reports have been moved to the rejected status.", "Builder Archived", <button className="pp-button" onClick={this.hideMessage}>OK</button>);
						} else {
							if(result.messages) {
								this.showMessage(result.messages.join("\n"));
							}
						}
					},
					(error) => {
						this.setState({
							error
						});
						this.showMessage('Something went wrong. Please try again later.');
					}
				);
			} else {
				alert("Builder ID can not be empty.");
			}
		} else {
			alert("No BMY ID is set.");
		}
	}

	confirmDeactivateModel() {
		var messageButtons = <span class="pp-button-wrapper">
			<button type="button" className="pp-button" onClick={this.deactivateModel}>Deactivate Model</button>
			<p className="pp-instruction">or</p>
			<button type="button" className="pp-secondary-button" onClick={this.hideMessage}>Cancel</button>
		</span>;

		this.showMessage('Deactivating this model will deactivate all boats under this model as well as move all sizing forms/reports with this model to the rejected state. Are you sure you want to deactivate the model?', 'Deactivate this model?', messageButtons);
	}

	deactivateModel() {
		if (this.state.bmyInfo.bmy_id) {
			let modelId = this.state.modelInfo.selectedId;

			if(modelId !== "") {
				let formData = new FormData();

				formData.append("model_id", modelId);

				this.Auth.post('/deactivate/model', formData)
				.then(
					(result) => {
						if(result.success) {
							this.showMessage("All single boats with this model have been deactivated. All related sizing forms/reports have been moved to the rejected status.", "Model Archived", <button className="pp-button" onClick={this.hideMessage}>OK</button>);
						} else {
							if(result.messages) {
								this.showMessage(result.messages.join("\n"));
							}
						}
					},
					(error) => {
						this.setState({
							error
						});
						this.showMessage('Something went wrong. Please try again later.');
					}
				);
			} else {
				alert("Model ID can not be empty.");
			}
		} else {
			alert("No BMY ID is set.");
		}
	}

	confirmDeactivateSingleBoat() {
		var messageButtons = <span class="pp-button-wrapper">
			<button type="button" className="pp-button" onClick={this.deactivateSingleBoat}>Deactivate Single Boat</button>
			<p className="pp-instruction">or</p>
			<button type="button" className="pp-secondary-button" onClick={this.hideMessage}>Cancel</button>
		</span>;

		this.showMessage('Deactivating this boat will move all sizing forms/reports with this boat to the rejected state. Are you sure you want to deactivate the boat?', 'Deactivate this boat?', messageButtons);
	}

	deactivateSingleBoat() {
		if (this.state.bmyInfo.bmy_id) {

			let formData = new FormData();

			formData.append("bmy_id", this.state.bmyInfo.bmy_id);

			this.Auth.post('/deactivate/bmy', formData)
			.then(
				(result) => {
					if(result.success) {
						this.showMessage("This single boat has been deactivated. All related sizing forms/reports have been moved to the rejected status.", "Boat Archived", <button className="pp-button" onClick={this.hideMessage}>OK</button>);
					} else {
						if(result.messages) {
							this.showMessage(result.messages.join("\n"));
						}
					}
				},
				(error) => {
					this.setState({
						error
					});
					this.showMessage('Something went wrong. Please try again later.');
				}
			);
		} else {
			alert("No BMY ID is set.");
		}
	}

	render() {

		const { bmyInfo,
				vesselInfo,
				builderInfo,
				modelInfo,
				year,
				configInfo,
				customerInfo,
				disableBMY,
				disableVessel,
				disableConfig,
				canEditSizingForm,
				unit,
				message,
				popupCallback,
				salesUserList,
			 	loading,
			 	displaySaveButton,
				displayReports } = this.state;

		let unitClass = "pp-unit-" + unit;
		var pageTitle = '',
			pageClass = "pp-create-boats-page " + unitClass,
			pageActions = '';

		if(this.state.bmyInfo && this.state.bmyInfo.bmy_id) {
			pageActions = (
				<a href={"/sizing-form?bmy="+this.state.bmyInfo.bmy_id} className="pp-plus-button">Create Sizing Form</a>
			)
		}

		if (this.bmy_id !== undefined) {
			pageTitle = 'Edit Boat'
		} else {
			pageTitle = 'Create Boat';
		}

		let createdStr = "";
		if(this.state.createdInfo) {
			createdStr = <p className="pp-created-by">Created by: {this.state.createdInfo.name} on {this.state.createdInfo.date}</p>
		}

		if (this.path == '/view-boats/:bmy_id') {
			pageTitle = this.state.builderInfo.selectedText + ' ' + this.state.modelInfo.selectedText + ', ' + this.state.year;
			pageActions = <div className="pp-page-actions-wrapper">
				<a href="/view-boats" className="pp-button">View all Boats</a> {pageActions}
			</div>;
		}

		let bmyEditButton = "";
		if(this.state.canEditBMY) {
			bmyEditButton = (
				<div className="pp-action-buttons pp-edit-bmy-buttons">
					<button type="submit" id="bmy-submit" className="pp-button" onClick={this.editBMYClick}>Edit</button>
				</div>
			)
		}
		if(this.state.isEditingBMY) {
			bmyEditButton = (
				<div className="pp-action-buttons pp-edit-bmy-buttons">
					<button type="submit" id="bmy-submit" className="pp-button" onClick={this.updateBMY}>Save</button>
					<p className="pp-instruction">or</p>
					<a className="pp-secondary-button" onClick={this.cancelEdit}>Cancel</a>
				</div>
			)
		}

		let deactivateButtons = "";
		if(this.state.canDeactivate&& this.state.isEditingBMY) {
			deactivateButtons = (
				<div className="pp-action-buttons">
					<button type="submit" className="pp-text-button" onClick={this.confirmDeactivateBuilder}>Deactivate Builder</button>
					<button type="submit" className="pp-text-button" onClick={this.confirmDeactivateModel}>Deactivate Model</button>
					<button type="submit" className="pp-text-button" onClick={this.confirmDeactivateSingleBoat}>Deactivate this Boat</button>
				</div>
			)
		}

		if (loading) {
			pageClass += " pp-loading";
		}

		return (
			<Page
				pageTitle={pageTitle}
				pageClass={pageClass}
				pageActions={pageActions}
			>

				{message &&
					<Popup body={message.body} title={message.title} actionButtons={message.actionButtons} />
				}

				<PageSection>
					{createdStr}
					<div className="pp-deactive-group">
						<BMYForm
							setBMY={this.setBMY}
							bmyInfo={bmyInfo}
							changeBuilder={this.changeBuilder}
							changeModel={this.changeModel}
							changeYear={this.changeYear}
							builderInfo={builderInfo}
							modelInfo={modelInfo}
							year={year}
							disableAll={disableBMY}
							isEditing={this.state.isEditingBMY}
							error={this.state.errors.bmy_id || false}
						/>
						{deactivateButtons}
					</div>
					{bmyEditButton}
					<ButtonGroup
						className="pp-units"
						options={['Metric', 'English']}
						selected={(this.state.unit === "Metric") ? 0 : 1}
						value={'Metric'}
						onChange={this.unitChange}
					/>
					<VesselForm
						bmyInfo={bmyInfo}
						vesselInfo={vesselInfo}
						onChange={this.vesselInfoChange}
						disableAll={disableVessel}
						errors={this.state.errors}
						disableHullName={true}
						units={this.state.unit}
					/>
					{displaySaveButton &&
						<div className="pp-action-buttons">
							<button
								type="submit"
								id="bmy-submit"
								className="pp-button"
								onClick={this.createBoat}>Save</button>
						</div>
					}
				</PageSection>

				{displayReports &&
					<PageSection
						className="pp-bmy-reports"
						sectionTitle="Sizing Reports for this boat"
					>
						<Table
							tableHeading={this.state.tablePublished.tableHeading}
							tableBody={this.state.tablePublished.tableBody}
							noResultsMessage="This boat is not used in any reports"
						/>
					</PageSection>
				}
			</Page>
		);
	}
}

export default CreateBoat;



// WEBPACK FOOTER //
// ./src/components/pages/CreateEditBoat.js